<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <core-card [actions]="[]">
      <div class="card-title w-100">
        <div class="row">
          <div class="col-md-3 col-12">
            <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" autocomplete="off" [(ngModel)]="searchKey" (ngModelChange)="searchResignedEmployees()" />
          </div>
          <div class="col-md-9 col-12 text-right" [ngClass.sm]="'d-none'">
            <div class="w-fit d-inline-block">
              <label class="d-flex align-items-center"
                >{{ "SHOW" | translate }}
                <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>
          </div>
        </div>
      </div>

      <!--desktop-->
      <div class="card-body px-0 pb-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="50"
          [scrollbarH]="true"
          [rowHeight]="_utilService.isDesktop ? 70 : 200"
          [limit]="tableLimit"
          [footerHeight]="50"
          [rows]="filteredResignedEmployees"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate), totalMessage: ('TOTAL' | translate).toLowerCase() }"
          [sorts]="[{ prop: 'closed_at', dir: 'desc' }]"
        >
          <ngx-datatable-column name="{{ 'FIRSTNAME' | translate }}" prop="complete_name" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <a target="_blank" routerLink="/dashboard/user/profile/{{ row.user_hash }}">{{ row.complete_name }}</a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'END_DATE' | translate }}" prop="date" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.date }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'FIGURE' | translate }}" prop="figure" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.figure_name ? row.figure_name : ("FIELD_NOT_SPECIFIED_FEMALE" | translate) }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'CITY' | translate }}" prop="working_city" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.working_city ? row.working_city : ("FIELD_NOT_SPECIFIED_FEMALE" | translate) }}</ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column name="{{ 'FIRSTNAME' | translate }}" prop="complete_name" [sortable]="true" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col-12">
                  <a class="font-medium-1" target="_blank" routerLink="/dashboard/user/profile/{{ row.user_hash }}">{{ row.complete_name }}</a>
                </div>
                <div class="col-12">
                  <span class="font-medium-1">{{ "END_DATE" | translate }} : {{ row.closed_at ? _utilService.formatDate(row.closed_at) : _utilService.formatDate(row.end_date) }}</span>
                </div>
                <div class="col-12">
                  <span class="font-medium-1">{{ "FIGURE" | translate }} : {{ row.figure_name ? row.figure_name : ("FIELD_NOT_SPECIFIED_FEMALE" | translate) }}</span>
                </div>
                <div class="col-12">
                  <span class="font-medium-1">{{ "CITY" | translate }} : {{ row.city_name ? row.city_name : ("FIELD_NOT_SPECIFIED_FEMALE" | translate) }}</span>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </core-card>
  </div>
</div>
